import { type ComponentProps } from 'react';
import { Loader } from 'rsuite';
import { classes } from '@/util/component-utils';
import styles from './Loading.module.css';

export interface LoadingProps extends ComponentProps<'div'> {
    message?: string;
    size?: "xs" | "sm" | "md" | "lg";
}

export default function Loading(props: LoadingProps) {
    const { className, message, ...divProps } = props;
    const size = props.size ? props.size : "md";
    return (
        <div className={classes(styles.container, className)} {...divProps}>
            <Loader size={size} backdrop content={message} center vertical />
        </div>
    )
}

// import { Loader, Placeholder } from 'rsuite';

// const App = () => (
//   <div>
//     <Placeholder.Paragraph rows={8} />
//     <Loader backdrop content="loading..." vertical />
//   </div>
// );

// ReactDOM.render(<App />, document.getElementById('root'));